import { useState, useEffect } from 'react';
import axios from 'axios';

export const useLocations = () => {
  const [locations, setLocations] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${process.env.REACT_APP_API_URL}/api/payables/locations`, { headers })
      .then(r => setLocations(r.data))
      .catch(() => setLocations([]))
      .finally(() => setLoading(false));
  }, []);

  return { locations, loading };
};
